import {modulo} from '../../../static/js/lib/utilities';


/**
 * scroll sections use a data attribute
 *    so anchors can use actuall id attribute
 * @param {HTMLSectionElement} $section
 * @return {String}
 */
function getSectionId($section) {
  return $section.getAttribute('data-id');
}

export default class SectionSelector {
  constructor() {
    this.$scrollSections = document.querySelectorAll('.homepageScrollSection');
    this.$siteHeader = document.querySelector('.site-header');
    this.selectedSectionId;
    this.$selectedFixedSection;
    this.$visibleFixedSections = [];
    this.$selectedNavLink;
    this.scrollSectionIds = [...this.$scrollSections].map(getSectionId);
    this.onIntersection = this.onIntersection.bind(this);

    this.observer = new window.IntersectionObserver(this.onIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1],
    });
    this.$scrollSections.forEach((target) => this.observer.observe(target));

    // set initial section ratios
    this.sectionRatios = {};
    this.$scrollSections.forEach(($section) => {
      const id = getSectionId($section);
      this.sectionRatios[id] = 0;
    });

    this.updateMeasurements();
  }

  updateMeasurements() {
    this.sectionHeights = {};
    this.$scrollSections.forEach(($section) => {
      const id = getSectionId($section);
      this.sectionHeights[id] = $section.offsetHeight;
    });
  }

  onIntersection(entries) {
    // set selected section based on in-viewport height
    // update sectionRatio
    entries.forEach((entry) => {
      const id = getSectionId(entry.target);
      this.sectionRatios[id] = entry.intersectionRatio;
    });

    const sectionId = this.getMostVisibleSection();
    this.setSelectedSection(sectionId);
  }


  getMostVisibleSection() {
    let maxHeight = 0;
    let sectionId;
    Object.keys(this.sectionRatios).forEach((id) => {
      const ratio = this.sectionRatios[id];
      const height = this.sectionHeights[id];
      const visibleHeight = ratio * height;
      if (visibleHeight >= maxHeight) {
        sectionId = id;
        maxHeight = visibleHeight;
      }
    });
    return sectionId;
  }

  /**
   * add isVisible and isSelected classes to fixed sections
   * @param {String} id - section
   */
  setSelectedSection(id) {
    if (id === this.selectedSectionId) return;
    // update body class
    document.body.classList.remove(`homepageBody--${this.selectedSectionId}`);
    this.selectedSectionId = id;
    document.body.classList.add(`homepageBody--${this.selectedSectionId}`);

    this.updateVisibleSections(id);
    this.updateNav();
  }

  updateVisibleSections(id) {
    const $fixedSection = document.querySelector(`.homepageFixedSection--${id}`);
    // there should be a matching fixed section for every scrollable section
    if (!$fixedSection) return;
    // update isSelected class
    if (this.$selectedFixedSection) {
      this.$selectedFixedSection.classList.remove('isSelected');
    }
    this.$selectedFixedSection = $fixedSection;
    this.$selectedFixedSection.classList.add('isSelected');
    // update isVisible class
    const index = this.scrollSectionIds.indexOf(id);
    // get previous and next fixed sections
    const previousIndex = modulo(index - 1, this.scrollSectionIds.length);
    const nextIndex = modulo(index + 1, this.scrollSectionIds.length);
    const previousId = this.scrollSectionIds[previousIndex];
    const nextId = this.scrollSectionIds[nextIndex];
    this.$visibleFixedSections.forEach(($section) => {
      $section.classList.remove('isVisible');
    });
    this.$visibleFixedSections = [
      document.querySelector(`.homepageFixedSection--${previousId}`),
      this.$selectedFixedSection,
      document.querySelector(`.homepageFixedSection--${nextId}`),
    ].filter(Boolean);
    this.$visibleFixedSections.forEach(($section) => {
      $section.classList.add('isVisible');
    });
  }

  updateNav() {
    if (this.$selectedNavLink) {
      this.$selectedNavLink.classList.remove('active');
    }
    this.$selectedNavLink = this.$siteHeader.querySelector(`[href*="#${this.selectedSectionId}"]`);
    if (this.$selectedNavLink) {
      this.$selectedNavLink.classList.add('active');
    }
  }

  unmount() {
    this.observer.disconnect();
  }
}
